/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** Models */
import { BydModel } from '@sixense/byd-core-service';
import { BydOrganisationFonction } from '../models/byd-organisation-fonction';
import { BydOrganisationFonctionInterface } from '../interfaces/byd-organisation-fonction.interface';

@Injectable({
  providedIn: 'root',
})
export class BydOrganisationsFonctionsService<T = unknown> extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get organisation right.
   *
   * @param  organisationId Organisation ID
   * @returns Observable type `<DsOrganisationFonction[]>`
   */
  public getOrganisationFonctions(organisationId: number): Observable<BydModel<BydOrganisationFonction>> {
    this.path = `/dsorga/v1/organisations/${organisationId}/right`;
    return this.getModels<BydOrganisationFonction>();
  }

  /**
   * Update organisation right.
   *
   * @param organisationId Organisation ID.
   * @param rights test.
   * @returns Observable of json
   */
  public updateOrganisationsFonctions(organisationId: number, rights: BydOrganisationFonction[]): Observable<T> {
    this.path = `/dsorga/v1/organisations/${organisationId}/right`;
    return this.put<T>({ body: rights });
  }

  /**
   * Create DsOrganisationFonction instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsOrganisationFonction` instance.
   */
  public createNewInstance(jsonObject: BydOrganisationFonctionInterface): BydOrganisationFonction {
    return new BydOrganisationFonction(jsonObject);
  }
}
